<template>
  <!-- 交卷结果页  -->
  <div id="results_page">
    <Head></Head>
    <div class="results-body" v-if="customerExaminationTestLogEntity">
      <div class="currhead">
        <h1 class="currh1" v-if="answerData.courseEntity">{{answerData.courseEntity.courseName}}</h1>
        <div @click="slices" class="currfont">
          返回
          <img alt src="@/assets/img/slices/slices.png" style="margin-left: 10px" />
        </div>
      </div>
      <div class="chapter">
        <img alt class="chapter-img" src="@/assets/img/chapter.png" />
        {{answerData.examinationName}}
      </div>
      <img
        class="result_img"
        src="@/assets/img/result/gold.png"
        v-if="customerExaminationTestLogEntity.correctRate >= 95"
      />
      <img
        class="result_img"
        src="@/assets/img/result/silver.png"
        v-else-if="customerExaminationTestLogEntity.correctRate >= 60"
      />
      <img class="result_img" src="@/assets/img/result/copper.png" v-else />
      <div class="percentage">正确率：{{customerExaminationTestLogEntity.correctRate}}%</div>
      <div class="title" v-if="customerExaminationTestLogEntity.correctRate >= 95">太赞了，基本都正确了呢！</div>
      <div class="title" v-else-if="customerExaminationTestLogEntity.correctRate >= 60">太棒了，完成得还不错哦！</div>
      <div class="title" v-else>本次练习不够理想哦，加油哦！</div>
      <div class="answer_rel">
        <div class="answer_item">
          <span>不计分：{{customerExaminationTestLogEntity.noScore}}题</span>
        </div>
        <div class="answer_item">
          <span>正&emsp;确：{{customerExaminationTestLogEntity.trueCount}}题</span>
        </div>
        <div class="answer_item">
          <span>错&emsp;误：{{customerExaminationTestLogEntity.falseCount}}题</span>
        </div>
        <div class="answer_item">
          <span>用&emsp;时：{{customerExaminationTestLogEntity.useTime | timeFormat}}</span>
        </div>
        <div class="answer_item">
          <span>时&emsp;间：{{customerExaminationTestLogEntity.startTime | getTime}}</span>
        </div>
      </div>
      <div class="result_btn">
        <div @click="getResult()" class="btn_resolve">
          <span>查看解析</span>
        </div>
        <div @click="backBank()" class="btn_back">重新答题</div>
      </div>
    </div>
  </div>
</template>
<script>
import Head from '@/components/pc/Head'
import * as QUESTION_API from '@/api/ExaminationAPI'
import * as DateUtil from '@/api/dateUtil'

export default {
  name: 'resultsPage',
  data () {
    return {
      answerData: '',
      customerExaminationTestLogEntity: {}
    }
  },
  components: {
    Head
  },
  computed: {},
  filters: {
    timeFormat: function (value) {
      var num = value;
      var s = num % 60;
      num = parseInt(num / 60);
      var m = num % 60;
      num = parseInt(num / 60);
      var h = num;
      if (h > 0) {
        return h + '小时' + m + '分' + s + '秒';
      } else {
        return m + '分' + s + '秒';
      }
    },
    getSecond (val) {
      if (val > 0) {
        return Math.ceil(val / 60)
      } else {
        return 0
      }
    },
    getTime (val) {
      if (val) {
        return DateUtil.formatDateNoSecond(val * 1000)
      }
    }
  },
  mounted () {
    if (this.$route.params.data) {
      this.answerData = this.$route.params
    } else {
      this.answerData = JSON.parse(sessionStorage.getItem('results_page')) || ''
      console.log(55555)
      console.log(this.answerData)
    }
    this.getCustomerExaminationResult()
  },
  methods: {
    //回退
    slices () {
      this.$router.push('/pc/CourseDetail')
    },
    //查询考试结果
    getCustomerExaminationResult () {
      let data = {
        customerExaminationTestLogId: this.answerData.customerExaminationTestLogId
      }
      QUESTION_API.getCustomerExaminationResult(data).then(res => {
        if (res && Number(res.code) === 0) {
          this.customerExaminationTestLogEntity = res.data
        } else {
          this.$message.warning(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 查看解析
    getResult () {
      let parsingObj = {
        examinationData: this.answerData,
        courseId: this.answerData.courseId,
        examinationId: this.answerData.examinationId,
        courseName: this.answerData.courseEntity.courseName,
        typeId: this.answerData.typeId
      }
      this.$router.push({
        name: 'ParsingView',
        params: parsingObj
      })
      sessionStorage.setItem('parsing', JSON.stringify(parsingObj))
    },


    //重新答题
    backBank () {
      let data = {
        examination: this.answerData,
        examinationId: this.answerData.examinationId,
        courseId: this.answerData.courseId,
        courseName: this.answerData.courseEntity.courseName,
        actionType: 1,
        testTime: this.answerData.testTime
      }
      setTimeout(() => {
        this.$router.push(
          {
            name: 'AnswerView',
            params: data
          }
        )
        sessionStorage.setItem('answer', JSON.stringify(data))
      }, 200)
    }
  },
}

</script>

<style lang="less" scoped>
#results_page {
  .results-body {
    max-width: 1282px;
    margin: 30px auto;
    padding: 30px 40px;
    display: flex;
    background-color: #fff;
    flex-direction: column;
    align-items: center;
    .chapter {
    }
    .chapter-img {
      display: inline;
      width: 32px;
      height: 38px;
      vertical-align: middle;
    }
    .currhead {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
    .currh1 {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 64px;
    }
    .currfont {
      font-size: 16px;
      color: rgba(51, 51, 51, 1);
      line-height: 64px;
    }
    .percentage {
      margin: 1.125rem 0;
      font-size: 18px;
      color: #222;
    }
    .answer_rel {
      width: 15.375rem;
      font-size: 16px;
      color: #222;
      .answer_item {
        line-height: 33px;
        display: flex;
        justify-content: space-between;
        color: #999999;
        &:first-child {
          margin-top: 25px;
        }
      }
    }
    .result_img {
      margin-top: 39px;
      width: 110px;
      height: 173px;
    }
    .result_btn {
      width: 15.375rem;
      display: flex;
      justify-content: space-around;
      margin-top: 31px;
      .btn_resolve {
        width: 98px;
        height: 36px;
        background: linear-gradient(
          90deg,
          rgba(77, 205, 253, 1),
          rgba(71, 162, 255, 1)
        );
        border-radius: 4px;
        line-height: 36px;
        color: #ffffff;
        text-align: center;
      }
      .btn_back {
        width: 98px;
        height: 36px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(242, 242, 242, 1);
        border-radius: 4px;
        line-height: 36px;
        text-align: center;
      }
    }
  }
}
</style>